import styled from 'styled-components';
export const Badge = styled.div `
  display: grid;

  grid-auto-flow: column;
  gap: 6px;
  align-items: center;

  border: 1px solid;
  border-radius: 100px;
  border-color: color-mix(in srgb, var(--color-on-background) 30%, transparent);

  padding: 4px 10px;

  background-color: color-mix(in srgb, var(--color-on-background) 10%, transparent);

  color: var(--color-on-background);
`;
export const Text = styled.div `
  font-size: 14px;
  line-height: 1.5;
`;
export const Emoji = styled.div `
  font-weight: normal;
  font-family: 'Segoe UI Emoji';
`;
export const Image = styled.img `
  width: 16px;
  height: 16px;
  object-fit: contain;
`;
